module.exports = __webpack_public_path__ + "img/mingyong78.24e94182.png";